// const cursorRounded = document.querySelector('#pointer');
// let mouseX = 0;
// let mouseY = 0;
//
// const moveCursor = (e) => {
//     mouseX = e.pageX;
//     mouseY = e.pageY;
// }
//
// const updateCursor = () => {
//     cursorRounded.style.transform = `translate(${mouseX}px, ${mouseY}px)`;
//     requestAnimationFrame(updateCursor);
// }
//
// window.addEventListener('mousemove', moveCursor);
// updateCursor();
//
// jQuery(document).ready(function() {
//
//     $(".custom-mouse").mouseenter(function() {
//         $("#pointer").fadeIn('fast');
//         // $(this).parent().addClass("color-text");
//     });
//
//     $(".custom-mouse").mouseleave(function() {
//         $("#pointer").fadeOut('fast');
//         // $(this).parent().removeClass("color-text");
//     });
//
//
// });





jQuery(document).ready(function() {
    const buttons = document.querySelectorAll('.category-list li');
    const categories = document.querySelectorAll('.our-services-section__content-container');
    const containerHeights = document.querySelectorAll('.our-services-section__text-container');

    if(containerHeights.length > 0) {
        let heightToSet = window.getComputedStyle(containerHeights[2]).height;

        function setContainerHeights() {
            for (let i = 0; i < containerHeights.length; i++) {

                if(i !== 2) {
                    containerHeights[i].style.height = heightToSet;
                }
            }
        }

        setContainerHeights();

        for (let i = 0; i < buttons.length; i++) {
            buttons[i].addEventListener('click', () => {
                for (let j = 0; j < buttons.length; j++) {
                    if(i !== j) {
                        if(buttons[j].classList.contains('chosen-option')) {
                            categories[j].style.opacity = '0';
                            buttons[j].classList.remove('chosen-option');
                            categories[j].overflow= 'hidden';
                            categories[j].style.height = '0';
                            categories[j].style.visibility = 'hidden';
                        }
                    } else {
                        buttons[i].classList.add('chosen-option');
                        categories[i].style.visibility = 'visible';
                        categories[i].style.height = 'fit-content';
                        categories[i].style.opacity = '1';
                    }
                }
            })
        }
    }
});